<template>
  <span v-if="array"
    ><span v-for="(item, i) of displayedArray" :key="i"
      >{{ i18n ? $gettext(item, i18nContext) : item }}<span v-if="i != array.length - 1">, </span>
    </span></span
  >
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue';

const props = defineProps({
  array: {
    type: Array as PropType<string[]>,
    default: null,
  },
  i18n: {
    type: Boolean,
    default: true,
  },
  i18nContext: {
    type: String,
    default: undefined,
  },
  sortValues: {
    type: Boolean,
    default: false,
  },
});

const displayedArray = computed(() => (props.sortValues ? [...props.array].sort() : props.array));
</script>
